import React, { useEffect, useState } from 'react';
import { countriesData } from '../mock/mock';

const CountryCubes = () => {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const i = setInterval(() => setTick((t) => t + 1), 3000);
    return () => clearInterval(i);
  }, []);

  const max = Math.max(...countriesData.map((c) => c.count));

  return (
    <section className="rounded-2xl border border-white/5 bg-gradient-to-b from-white/[0.03] to-transparent p-5 h-full">
      <div className="flex items-center justify-between mb-4">
        <p className="text-[10px] uppercase tracking-[0.25em] text-white/40 font-mono">Sites scrapés par pays</p>
        <span className="text-[9px] font-mono text-cyan-300/70">3D · LIVE</span>
      </div>

      <div className="flex items-end justify-between gap-2 h-[220px] px-2" style={{ perspective: '900px' }}>
        {countriesData.map((c, i) => {
          const heightPct = (c.count / max) * 100;
          const pulse = tick % countriesData.length === i;
          return (
            <div key={c.name} className="flex flex-col items-center gap-2 flex-1 group">
              <div className="relative h-[170px] w-full flex items-end justify-center">
                <div
                  className="relative w-full max-w-[42px]"
                  style={{
                    height: `${heightPct}%`,
                    transformStyle: 'preserve-3d',
                    transform: 'rotateX(-18deg) rotateY(-25deg)',
                    transition: 'height 1.2s cubic-bezier(0.2,0.8,0.2,1)',
                    animation: `cube-in 0.9s cubic-bezier(0.2,0.8,0.2,1) ${i * 0.08}s both`,
                  }}
                >
                  {/* Front face */}
                  <div
                    className="absolute inset-0 rounded-sm"
                    style={{
                      background: 'linear-gradient(180deg, #22d3ee 0%, #a855f7 50%, #ec4899 100%)',
                      boxShadow: pulse ? '0 0 20px rgba(236,72,153,0.7)' : '0 0 10px rgba(168,85,247,0.4)',
                      transition: 'box-shadow 0.4s',
                    }}
                  >
                    <div className="absolute inset-0 opacity-30" style={{ background: 'linear-gradient(180deg, transparent, rgba(255,255,255,0.25), transparent)', animation: 'shimmer-v 3s ease-in-out infinite' }} />
                  </div>
                  {/* Right face */}
                  <div
                    className="absolute top-0 right-0 h-full rounded-sm"
                    style={{
                      width: '12px',
                      background: 'linear-gradient(180deg, #0891b2 0%, #7e22ce 50%, #be185d 100%)',
                      transform: 'rotateY(90deg) translateZ(12px)',
                      transformOrigin: 'right center',
                      filter: 'brightness(0.7)',
                    }}
                  />
                  {/* Top face */}
                  <div
                    className="absolute top-0 left-0 w-full rounded-sm"
                    style={{
                      height: '12px',
                      background: 'linear-gradient(90deg, #22d3ee 0%, #a855f7 50%, #ec4899 100%)',
                      transform: 'rotateX(90deg) translateZ(12px)',
                      transformOrigin: 'top center',
                      filter: 'brightness(1.3)',
                    }}
                  />
                  {/* Count label */}
                  <div className="absolute -top-6 left-1/2 -translate-x-1/2 font-mono text-xs text-white tabular-nums">{c.count}</div>
                </div>
              </div>
              <div className="text-[10px] font-mono text-white/60 uppercase tracking-wider text-center leading-tight">{c.name}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default CountryCubes;
